module.exports = __webpack_public_path__ + "static/media/message_icon.224fb2da.svg";